import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ChatHistoryEntry } from '../../../core/models/chat-history-entry';

@Component({
  selector: 'app-chat-history-sidebar',
  standalone: false,
  templateUrl: './chat-history-sidebar.component.html',
  styleUrls: ['./chat-history-sidebar.component.scss']
})
export class ChatHistorySidebarComponent implements OnChanges {
  @Input() chatHistory: ChatHistoryEntry[] = [];
  @Input() activeChatId: string | null = null;
  @Input() isOpen = false;

  @Output() chatSelected = new EventEmitter<ChatHistoryEntry>();
  @Output() newChat = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  searchText = '';

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.updatePosition();
    }
  }

  get filteredChats(): ChatHistoryEntry[] {
    if (!this.searchText.trim()) {
      return this.chatHistory;
    }
    const term = this.searchText.toLowerCase();
    return this.chatHistory.filter(chat =>
      this.getChatPreview(chat).toLowerCase().includes(term)
    );
  }

  getChatPreview(chat: ChatHistoryEntry): string {
    // El listado ya no incluye la historia entera — solo `lastMessage`
    // (preview de ~200 chars del último mensaje persistido). La historia
    // completa se carga on-demand via KnowledgeService.getChatHistoryDetail
    // cuando el usuario clica el chat.
    return chat.lastMessage || chat.summary || '';
  }

  selectChat(chat: ChatHistoryEntry): void {
    this.chatSelected.emit(chat);
  }

  onNewChat(): void {
    this.newChat.emit();
  }

  close(): void {
    this.closed.emit();
  }

  private updatePosition(): void {
    const parent = this.el.nativeElement.parentElement;
    if (!parent) return;
    const rect = parent.getBoundingClientRect();
    const host = this.el.nativeElement;
    host.style.setProperty('--chat-history-top', `${rect.top}px`);
    host.style.setProperty('--chat-history-left', `${rect.left}px`);
    host.style.setProperty('--chat-history-height', `${rect.height}px`);
  }
}
